module.exports = __webpack_public_path__ + "img/guantes.ef2455d6.png";